/**
 * 静态资源 / 第三方地址请求实例（与主业务后端的 indexBase 区分开）。
 *
 * 适用：OBS 上的文件（txt / md / html / 音频）、HEAD 取文件大小、站点自身的 version.json。
 * 不复用 indexBase（HTTPRequest）的原因：
 * 1. 它会自动带 token、teamId 等业务头：发往第三方域名既泄露登录凭证，
 *    自定义头还会触发 CORS 预检，OBS 未放行时直接跨域失败；
 * 2. 它的响应拦截按后端 { code, data } 结构归一化，且只返回 res.data，HEAD 拿不到响应头；
 * 3. 网络失败会跳转「网络异常」页、并且永远 resolve({})，资源加载失败不应影响整页。
 *
 * 因此这里是一个干净的 axios 实例：无 baseURL、不加任何业务头、失败正常 reject，
 * 由调用方按场景决定降级方式。
 *
 * @date 2026-10-14
 * @ai-generated true
 * @ai-tool Claude Code
 */
import axios from 'axios'

// 资源请求超时：音频 / HTML 文件可能较大，给 60s；version.json 等小文件不会触达
const RESOURCE_TIMEOUT = 60000

const resourceRequest = axios.create({
  timeout: RESOURCE_TIMEOUT
})

export default resourceRequest
